export default __webpack_public_path__ + "static/media/happy-star.b5515d91.svg";